import { render } from "./index.vue?vue&type=template&id=b756d242&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b756d242&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-b756d242"

export default script